import { defineCopy } from "../intl";

import { PLAN_CATALOG_COPY_EN_US } from "./en-us/plan-catalog.copy";
import { PLAN_CATALOG_COPY_ES_ES } from "./es-es/plan-catalog.copy";

/** Padrões da vitrine. Moram no código, não no banco: mudar a frase é deploy, não migração. */
export const PLAN_CATALOG_COPY_PT_BR = {
  priceOnRequestLabel: "Plano sob consulta",
  contactCtaLabel: "Falar com a gente",
  monthlySuffix: "/mês",
} as const;

export const PLAN_CATALOG_COPY = defineCopy(PLAN_CATALOG_COPY_PT_BR, {
  "en-US": PLAN_CATALOG_COPY_EN_US,
  "es-ES": PLAN_CATALOG_COPY_ES_ES,
});
